import { render, staticRenderFns } from "./EditLoyaltyReward.vue?vue&type=template&id=2a3d1eee&"
import script from "./EditLoyaltyReward.vue?vue&type=script&lang=js&"
export * from "./EditLoyaltyReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports